module.exports = __webpack_public_path__ + "img/14-2.c64a8bcb.jpg";